import { c as _c } from "react/compiler-runtime";
import { AddIcon, PenIcon } from '@systemeio/ui/icons';
import { Modal, ModalSizeEnum, PrimaryButton, Tooltip } from '@systemeio/ui';
import { SmsTemplateForm, SmsTemplateFormProps } from 'modules/sms/components/sms-template-form';
import { useSmsTemplate } from 'modules/sms/hooks/use-sms-template';
import { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useModal } from 'shared/hooks/use-modal';
interface Props extends Pick<SmsTemplateFormProps, 'templateId' | 'onSuccess'> {
  noRedirectOnNotFoundError?: boolean;
}
export function SmsTemplateCreateEditModal(t0) {
  const $ = _c(30);
  const {
    templateId,
    onSuccess,
    noRedirectOnNotFoundError
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const modal = useModal();
  const {
    template
  } = useSmsTemplate(templateId, noRedirectOnNotFoundError);
  const [isFetching, setIsFetching] = useState(false);
  let t1;
  if ($[0] !== modal || $[1] !== t || $[2] !== templateId) {
    t1 = templateId ? <Tooltip mode="hover" label={t("dashboard.automation_rule.edit.edit_sms")}><button onClick={() => modal.open()} className="group outline-hidden"><PenIcon className="fill-fill-primary main-transition-colors group-hover:fill-brand-primary group-focus-visible:fill-brand-primary h-[16px] w-[16px]" /></button></Tooltip> : <Tooltip mode="hover" label={t("dashboard.automation_rule.edit.create_sms")}><button onClick={() => modal.open()} className="group outline-hidden"><AddIcon className="fill-fill-primary main-transition-colors group-hover:fill-brand-primary group-focus-visible:fill-brand-primary" /></button></Tooltip>;
    $[0] = modal;
    $[1] = t;
    $[2] = templateId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t || $[5] !== templateId) {
    t2 = templateId ? t("dashboard.sms.edit_sms_template") : t("dashboard.sms.create_sms_template");
    $[4] = t;
    $[5] = templateId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = modal.opened;
  const t4 = modal.close;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = t6 => {
      const {
        isFetching: isFetching_0
      } = t6;
      return setIsFetching(isFetching_0);
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== modal || $[9] !== onSuccess) {
    t6 = async data => {
      await onSuccess?.(data);
      modal.close();
    };
    $[8] = modal;
    $[9] = onSuccess;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6 || $[12] !== template || $[13] !== templateId) {
    t7 = <SmsTemplateForm templateId={templateId} data={template} inModal={true} onStatusChange={t5} onSuccess={t6} />;
    $[11] = t6;
    $[12] = template;
    $[13] = templateId;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("global.save");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== isFetching || $[18] !== t8) {
    t9 = <PrimaryButton form={SmsTemplateForm.formId} className="mt-10 self-center" isFetching={isFetching}>{t8}</PrimaryButton>;
    $[17] = isFetching;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== isFetching || $[21] !== modal.close || $[22] !== modal.opened || $[23] !== t2 || $[24] !== t7 || $[25] !== t9) {
    t10 = <Modal size={ModalSizeEnum.big} title={t2} opened={t3} onClose={t4} contentClassName="flex flex-col" isFetching={isFetching}>{t7}{t9}</Modal>;
    $[20] = isFetching;
    $[21] = modal.close;
    $[22] = modal.opened;
    $[23] = t2;
    $[24] = t7;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t1 || $[28] !== t10) {
    t11 = <>{t1}{t10}</>;
    $[27] = t1;
    $[28] = t10;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}